import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-584c55c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "drawer",
  role: "dialog"
}
const _hoisted_2 = { class: "drawer__panel" }
const _hoisted_3 = { class: "drawer__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "drawer__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "drawer__overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.header) + " ", 1),
        _renderSlot(_ctx.$slots, "headerExtra", {}, undefined, true),
        _createElementVNode("button", {
          class: "button--ghost drawer__close",
          "data-test": "button-drawerButtonClose",
          title: "Close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["drawer__main", { 'drawer__main--not-scrollable': _ctx.notScrollable }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2),
      (_ctx.hasFooterSlot())
        ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}